import { POST_LODGING_POLICY_FAILURE, POST_LODGING_POLICY_REQUEST, POST_LODGING_POLICY_SUCCESS, PostLodgingPolicyActionTypes, PostLodgingPolicyState } from './types';

const defaultState: PostLodgingPolicyState = {
  isLoading: false,
  errorMessage: "",
};

export default function postLodgingPolicy(state = defaultState, action: PostLodgingPolicyActionTypes): PostLodgingPolicyState {
  switch (action.type) {
    case POST_LODGING_POLICY_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case POST_LODGING_POLICY_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case POST_LODGING_POLICY_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
